var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 68,
    viewBox: "0 0 50 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8224_3447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9205 29.3751C21.8397 29.3751 16.0996 23.6947 16.0996 16.6876C16.0996 9.68041 21.8397 4 28.9205 4C36.0013 4 41.7414 9.68041 41.7414 16.6876C41.7414 23.6947 36.0013 29.3751 28.9205 29.3751Z",
    fill: "url(#paint0_linear_8224_3447)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.40973 67.2362C0.631156 67.2362 0 66.6051 0 65.8265C0 50.4072 12.9565 37.9229 28.9205 37.9229C44.8844 37.9229 57.8409 50.4072 57.8409 65.8265C57.8409 66.6051 57.2098 67.2362 56.4312 67.2362H1.40973Z",
    fill: "#0C9CB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9205 29.3751C21.8397 29.3751 16.0996 23.6947 16.0996 16.6876C16.0996 9.68041 21.8397 4 28.9205 4C36.0013 4 41.7414 9.68041 41.7414 16.6876C41.7414 23.6947 36.0013 29.3751 28.9205 29.3751Z",
    fill: "#0C9CB2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8224_3447",
    x: 8.09961,
    y: 0,
    width: 41.6426,
    height: 41.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8224_3447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8224_3447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8224_3447",
    x1: 21.8206,
    y1: 39.8535,
    x2: 48.7876,
    y2: 25.4277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59D004"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.99a63a77c47094276fdc05678574a285.svg";
export { ForwardRef as ReactComponent };